var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframediv"},[_c('iframe',{staticClass:"iframeclass",attrs:{"src":_vm.url,"width":"100%","height":"100%","scrolling":"no","frameborder":"0","border":"0","marginwidth":"0","marginheight":"0","allowtransparency":"yes","type":"application/*"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }